import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from '../core/services/authentication/auth.service';


@Injectable()
export class CanActivateAuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router  ) { }

  canActivate() {
    // If the user is not logged in we'll send them back to the home page
    if (!this.authService.isAuthenticated()) {
      //alert('No estás logueado');
      this.router.navigate(['auth']);
      return false;
    }

    return true;
  }
}
